import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=7001d9ac"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=7001d9ac&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7001d9ac')) {
      api.createRecord('7001d9ac', component.options)
    } else {
      api.reload('7001d9ac', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=7001d9ac", function () {
      api.rerender('7001d9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/orderDetail.vue"
export default component.exports